import {createContext} from 'react';

import type {DashboardAdaptiveDensityController} from '../types/DashboardAdaptiveDensityController';

export const DashboardAdaptiveDensityContext =
  createContext<DashboardAdaptiveDensityController | null>(null);
